<template>
    <div class="relative">
        <ListItemButton
            :dusk="`${duskPrefix}Chicago`"
            class="text-neutral-500 dark:text-neutral-300"
            :aria-expanded="showSubmenu"
            aria-haspopup="menu"
            @click="toggleSubmenu"
            @mouseenter="showSubmenu = true"
            @mouseleave="handleMouseLeave"
        >
            <div class="flex w-full items-center" :class="{ 'justify-between': chevronPosition === 'right' }">
                <svg-icon v-if="chevronPosition === 'left'" icon="chevron-left" class="mr-2 h-4 w-4" />
                <span>{{ labels.Chicago }}</span>
                <svg-icon v-if="chevronPosition === 'right'" icon="chevron-right" class="h-4 w-4" />
            </div>
        </ListItemButton>
        <transition name="slide-fade">
            <div
                v-show="showSubmenu"
                :class="['absolute -top-16 z-[70]', submenuPositionClass]"
                @mouseenter="showSubmenu = true"
                @mouseleave="showSubmenu = false"
            >
                <ListDropdown role="menu" class="w-[194px]">
                    <ListItemButton
                        v-for="subformat in subformats"
                        :key="subformat"
                        :dusk="`${duskPrefix}${subformat}`"
                        class="py-3 text-neutral-500 dark:text-neutral-300"
                        @click="selectSubformat(subformat)"
                    >
                        {{ labels[subformat] }}
                    </ListItemButton>
                </ListDropdown>
            </div>
        </transition>
    </div>
</template>

<script>
import ListItemButton from './ListItemButton.vue';
import ListDropdown from './ListDropdown.vue';

export default {
    components: {
        ListItemButton,
        ListDropdown,
    },
    props: {
        subformats: {
            type: Array,
            required: true,
        },
        labels: {
            type: Object,
            required: true,
        },
        duskPrefix: {
            type: String,
            required: true,
        },
        submenuPositionClass: {
            type: String,
            required: true,
        },
        chevronPosition: {
            type: String,
            required: true,
            validator: value => ['left', 'right'].includes(value),
        },
    },
    emits: ['select'],
    data() {
        return {
            showSubmenu: false,
        };
    },
    methods: {
        /**
         * Toggles the Chicago submenu visibility.
         */
        toggleSubmenu() {
            this.showSubmenu = !this.showSubmenu;
        },
        /**
         * Hides the submenu. Intended to be called from the parent via $refs.
         */
        hideSubmenu() {
            this.showSubmenu = false;
        },
        /**
         * Handles mouse leave with a small delay to allow cursor movement to the submenu.
         */
        handleMouseLeave() {
            setTimeout(() => {
                if (!this.$el.querySelector('.absolute.left-full:hover, .absolute.right-full:hover')) {
                    this.showSubmenu = false;
                }
            }, 100);
        },
        /**
         * Emits the selected subformat and hides the submenu.
         * @param {string} subformat - The selected Chicago subformat key
         */
        selectSubformat(subformat) {
            this.$emit('select', subformat);
            this.showSubmenu = false;
        },
    },
};
</script>

<style scoped>
.slide-fade-enter-active,
.slide-fade-leave-active {
    transition: all 0.2s ease;
}

.slide-fade-enter-from,
.slide-fade-leave-to {
    opacity: 0;
    transform: translateX(10px);
}
</style>
